import React from "react";
import { useMoralis, useWeb3ExecuteFunction } from "react-moralis";
import { ethers } from "ethers";

function nftVault() {
  const { Moralis } = useMoralis();
  const contractProcessor = useWeb3ExecuteFunction();

  const balanceOfNFTEthers = async (
    contract,
    nftAddress,
    tokenId,
    nftNetwork
  ) => {
    if (!contract) return;
    try {
      const provider = new ethers.providers.JsonRpcProvider(
        nftNetwork.rpcUrls[0]
      );

      const abi = [
        {
          inputs: [
            {
              internalType: "address",
              name: "nftAddress",
              type: "address",
            },
            {
              internalType: "uint256",
              name: "tokenId",
              type: "uint256",
            },
          ],
          name: "balanceOf",
          outputs: [
            {
              internalType: "uint256",
              name: "",
              type: "uint256",
            },
          ],
          stateMutability: "view",
          type: "function",
        },
      ];

      const vault = new ethers.Contract(contract, abi, provider);
      return await vault.balanceOf(nftAddress, tokenId);
    } catch (error) {
      console.log(error);
    }
  };

  const balanceOfNFT = async (contract, nftAddress, tokenId, network) => {
    if (!contract) return;

    try {
      const abi = [
        {
          inputs: [
            {
              internalType: "address",
              name: "nftAddress",
              type: "address",
            },
            {
              internalType: "uint256",
              name: "tokenId",
              type: "uint256",
            },
          ],
          name: "balanceOf",
          outputs: [
            {
              internalType: "uint256",
              name: "",
              type: "uint256",
            },
          ],
          stateMutability: "view",
          type: "function",
        },
      ];

      const provider = new ethers.providers.JsonRpcProvider(network.rpcUrls[0]);
      const vaultContract = new ethers.Contract(contract, abi, provider);
      return await vaultContract.balanceOf(nftAddress, tokenId);
    } catch (error) {
      console.log(error);
    }
  };

  async function approve(collatsAddress, nftVaultAddress, onSuccess, onError) {
    var amount =
      "115792089237316195423570985008687907853269984665640564039457584007913129639935";

    let options = {
      contractAddress: collatsAddress,
      functionName: "approve",
      abi: [
        {
          inputs: [
            {
              internalType: "address",
              name: "spender",
              type: "address",
            },
            {
              internalType: "uint256",
              name: "amount",
              type: "uint256",
            },
          ],
          name: "approve",
          outputs: [
            {
              internalType: "bool",
              name: "",
              type: "bool",
            },
          ],
          stateMutability: "nonpayable",
          type: "function",
        },
      ],
      params: { spender: nftVaultAddress, amount: amount },
    };

    return await contractProcessor.fetch({
      params: options,
      onSuccess: onSuccess,
      onError: onError,
    });
  }

  async function getAllowance(nftVaultAddress, tokenAddress, owner, chainId) {
    let options = {
      address: tokenAddress,
      function_name: "allowance",
      chain: chainId,
      abi: [
        {
          constant: true,
          inputs: [
            {
              internalType: "address",
              name: "owner",
              type: "address",
            },
            {
              internalType: "address",
              name: "spender",
              type: "address",
            },
          ],
          name: "allowance",
          outputs: [
            {
              internalType: "uint256",
              name: "",
              type: "uint256",
            },
          ],
          payable: false,
          stateMutability: "view",
          type: "function",
        },
      ],
      params: {
        spender: nftVaultAddress,
        owner: owner,
      },
    };
    return await Moralis.Web3API.native.runContractFunction(options);
  }

  const addCollats = async (
    contract,
    nftAddress,
    tokenId,
    amountInWei,
    onSuccess,
    onError
  ) => {
    let options = {
      contractAddress: contract,
      functionName: "addCollats",
      abi: [
        {
          anonymous: false,
          inputs: [
            {
              indexed: true,
              internalType: "address",
              name: "from",
              type: "address",
            },
            {
              indexed: true,
              internalType: "address",
              name: "nftAddress",
              type: "address",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "tokenId",
              type: "uint256",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "amount",
              type: "uint256",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "balance",
              type: "uint256",
            },
          ],
          name: "CollatsAdded",
          type: "event",
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "nftAddress",
              type: "address",
            },
            {
              internalType: "uint256",
              name: "tokenId",
              type: "uint256",
            },
            {
              internalType: "uint256",
              name: "amount",
              type: "uint256",
            },
          ],
          name: "addCollats",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function",
        },
      ],
      params: {
        nftAddress: nftAddress,
        tokenId: tokenId,
        amount: amountInWei,
      },
    };

    return await contractProcessor.fetch({
      params: options,
      onSuccess: onSuccess,
      onError: onError,
    });
  };

  const withdrawCollats = async (
    contract,
    nftAddress,
    tokenId,
    amountInWei,
    receiver,
    onSuccess,
    onError
  ) => {
    let options = {
      contractAddress: contract,
      functionName: "withdrawCollats",
      abi: [
        {
          inputs: [
            {
              internalType: "address",
              name: "to",
              type: "address",
            },
            {
              internalType: "address",
              name: "nftAddress",
              type: "address",
            },
            {
              internalType: "uint256",
              name: "tokenId",
              type: "uint256",
            },
            {
              internalType: "uint256",
              name: "amount",
              type: "uint256",
            },
          ],
          name: "withdrawCollats",
          outputs: [
            {
              internalType: "bool",
              name: "",
              type: "bool",
            },
          ],
          stateMutability: "nonpayable",
          type: "function",
        },
      ],
      params: {
        to: receiver,
        nftAddress: nftAddress,
        tokenId: tokenId,
        amount: amountInWei,
      },
    };

    return await contractProcessor.fetch({
      params: options,
      onSuccess: onSuccess,
      onError: onError,
    });
  };

  return {
    balanceOfNFT,
    approve,
    getAllowance,
    addCollats,
    withdrawCollats,
    balanceOfNFTEthers,
  };
}

export default nftVault;
